import { useRef, useState } from 'react';
import { Html, HtmlProps } from '../../_helpers/Html/Html';
import { useFrame } from '@react-three/fiber';
import { interpolate } from '../../../_utils/interpolate';
import { round } from '../../../_utils/round';

export function Marker({ children, ...props }: HtmlProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
	const { style, position, ...rest } = props;
	const [showMarker, setShowMarker] = useState(false);
	const [x, setX] = useState(position?.[0] ?? 0);
	const [y, setY] = useState(position?.[1] ?? 0);
	const [z, setZ] = useState(position?.[2] ?? 0);

	const animation = useRef({
		showMarkerTime: 0,
	}).current;

	useFrame((_, delta) => {
		if (window)
			if (!showMarker) {
				animation.showMarkerTime += delta;
				if (animation.showMarkerTime > 0.3) {
					setShowMarker(true);
				}
			} else {
				const multiplier = round(interpolate(round(window.innerWidth / 100, 0), [3, 14], [6, 0]), 1);
				const defaultX = position?.[0] ?? 0;
				const defaultY = position?.[1] ?? 0;
				const defaultZ = position?.[2] ?? 0;

				const newX = defaultX - multiplier;
				if (x !== newX) {
					setX(newX);
				}
				const newY = defaultY + multiplier;
				if (y !== newY) {
					setY(newY);
				}
				const newZ = defaultZ - multiplier;
				if (z !== newZ) {
					setZ(newZ);
				}
			}
	});

	return (
		showMarker && (
			<Html
				// We just interpolate the visible state into css opacity and transforms
				className='absolute text-heading-5xs md:text-heading-2xs text-coral-100 cursor-pointer flex flex-col items-center max-w-fit'
				style={{ transition: 'all 0.2s', whiteSpace: 'nowrap', textAlign: 'center', ...style }}
				{...rest}
				position={[x, y, z]}
			>
				{children}
			</Html>
		)
	);
}
